import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class DashboardService {
  async getAllPrograms() {
    try {
      const response = await service.get(Urls.getApiUrl(`application/programs`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getProgramsById(programId) {
    try {
      const response = await service.get(Urls.getApiUrl(`application/program/${programId}`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

}

export const dashboardService = new DashboardService()
